export enum DeleteOptionRecipesStep {
  SelectOptionRecipes,
  ReviewChanges,
  Confirmation,
}